import { ContextExecutionParams } from './index';

export abstract class ExecutionContext<T> {
    abstract getContextParams(): ContextExecutionParams<T>;
}


